var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":"visible","title":_vm.$t('consent.title'),"ok-text":_vm.$t('consent.agree'),"cancel-text":_vm.$t('consent.disagree'),"closable":false,"centered":true,"mask-closable":false,"width":"100%"},on:{"ok":_vm.handleAgree,"cancel":_vm.handleDecline}},[_c('PrivacyPolicyContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }